import React, { Fragment, useCallback } from 'react'

import { useModifierContext } from 'public/components/online_ordering/ModifierContext'
import { getModifierThumbSrc } from 'public/components/online_ordering/modifierUtils'
import {
  ModifierGroup,
  Modifier
} from 'public/components/online_ordering/types'

import SelectionRow from './SelectionRow'

type ModifierGroupSelectionsProps = {
  groups: Modifier[]
  group: ModifierGroup
  inputType: 'radio' | 'checkbox'
  firstModifierGroup?: boolean
}

export const ModifierGroupSelections = ({
  groups,
  group,
  inputType,
  firstModifierGroup
}: ModifierGroupSelectionsProps) => {
  const { displayedModifier } = useModifierContext()

  const { guid, maxSelections } = group

  const groupHasImages = groups.some(
    (modifier) => !!getModifierThumbSrc(modifier)
  )

  const groupSelections = displayedModifier?.modifierGroups[guid]
  const selectedCount = Object.values(groupSelections ?? {})
    .map((mod) => mod.quantity)
    .reduce((curr, q) => curr + q, 0)
  const isModifierDisabled = useCallback(
    (modifier: Modifier) => {
      return (
        !!modifier.outOfStock ||
        (!groupSelections?.[modifier.itemGuid] &&
          inputType === 'checkbox' &&
          !!maxSelections &&
          selectedCount >= maxSelections)
      )
    },
    [groupSelections, inputType, maxSelections, selectedCount]
  )
  const firstNonDisabledSelectionIndex = groups.findIndex(
    (modifier) => !isModifierDisabled(modifier)
  )

  return (
    <div className='toggles'>
      {groups.map((modifier: Modifier, index) => (
        <Fragment key={modifier.itemGuid}>
          <SelectionRow
            modifier={modifier}
            inputType={inputType}
            groupGuid={guid}
            autoFocus={
              index === firstNonDisabledSelectionIndex && firstModifierGroup
            }
            canAddMore={!maxSelections || selectedCount < maxSelections}
            disabled={isModifierDisabled(modifier)}
            groupHasImages={groupHasImages}
          />
          <div className='divider' aria-hidden='true' />
        </Fragment>
      ))}
    </div>
  )
}
